var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoiceAccountingDocumetChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12865_23603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 11H12",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 8H9",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50047 16.9999L7.49047 16.9989C6.66047 16.9889 5.99047 16.3189 5.99047 15.4989H5.98047C5.98047 14.6689 6.65047 13.9989 7.47047 13.9889L7.46047 13.9879C8.28047 13.9879 8.95047 14.6579 8.96047 15.4779V15.4679C8.95047 16.2879 8.28047 16.9579 7.46047 16.9679L7.50047 16.9999Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 17.25H15.0005V21H12.5005H12.4905C12.2105 20.99 11.9905 20.77 11.9905 20.49V17.74C11.9805 17.46 12.2105 17.23 12.4805 17.23L12.5005 17.25Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5005 13H17.5005H17.4905C17.7605 12.99 17.9905 13.22 17.9905 13.49V20.99H14.9905V13.49C14.9805 13.21 15.2105 12.98 15.4805 12.98L15.5005 13Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5005 15.25H20.5005H20.4905C20.7605 15.24 20.9905 15.47 20.9905 15.74V20.49C20.9905 20.76 20.7605 20.99 20.4905 20.99H17.9905V15.74C17.9805 15.46 18.2105 15.23 18.4805 15.23L18.5005 15.25Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00032 21H5.00032L4.99032 20.999C3.88032 20.989 2.99032 20.099 2.99032 18.989V4.98896C2.98032 3.87896 3.88032 2.97896 4.98032 2.97896H13.1503H13.1403C13.6703 2.96896 14.1703 3.18896 14.5503 3.55896L17.3703 6.37896C17.7403 6.74896 17.9503 7.25896 17.9503 7.78896V9.95896",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12865_23603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceAccountingDocumetChart);
export default __webpack_public_path__ + "static/media/invoice-accounting-documet-chart.df31a3223fd66b48c2a605eedd17b65a.svg";
export { ForwardRef as ReactComponent };